import {
  DEFAULT_ICON_BACKGROUND_COLOR,
  DEFAULT_ICON_COLOR,
  DEFAULT_IMAGE_URL,
} from "@redotech/redo-model/default-values";
import { Icons } from "@redotech/redo-model/storefront/checkout-ui-customization";
import { InfoModalVersion } from "@redotech/redo-model/team";
import { InfoModal, WidgetAutocheck } from "@redotech/redo-model/widget";

export const getClassicWidgetTheme = ({
  autocheck,
}: {
  autocheck: WidgetAutocheck;
}): ClassicWidgetTheme => {
  return {
    color: autocheck.textColor,
    customCss: autocheck.customToggleCss,
    customPdpCss: autocheck.customPdpCss,
    fontSize: autocheck.toggleFontSize,
    html: autocheck.html,
    modalCustomizationsV2: autocheck.infoModal,
    modalVersion: autocheck.infoModal?.version,
    showInfoIcon: autocheck.infoModal?.cartIconEnabled,
    toggleCircleColor: autocheck.cartToggle.toggleCircleColor,
    toggleOffColor: autocheck.cartToggle.toggleOffColor,
    toggleOnColor: autocheck.cartToggle.toggleOnColor,
    toggleTextAfterRedo: autocheck.checkboxTextAfterRedo,
    icon: autocheck.displayIcon ? autocheck.icon : undefined,
    iconColor: autocheck.iconColor || DEFAULT_ICON_COLOR,
    iconBackgroundColor:
      autocheck.iconBackgroundColor || DEFAULT_ICON_BACKGROUND_COLOR,
    image_url: (autocheck.logo && autocheck.logo.trim()) || DEFAULT_IMAGE_URL,
    showIcons: autocheck.showIcons,
  };
};

export type ClassicWidgetTheme = {
  color: string;
  customCss?: string;
  customPdpCss?: string; // This field exists because PDP CSS was implemented before the concept of a widget system was fully established.
  fontSize?: number;
  html?: string | null;
  modalVersion?: InfoModalVersion;
  showInfoIcon?: boolean;
  toggleOffColor?: string;
  toggleOnColor?: string;
  toggleCircleColor?: string;
  toggleTextAfterRedo?: string | null;
  modalCustomizationsV2?: InfoModal;
  icon?: Icons;
  iconColor?: string;
  iconBackgroundColor?: string;
  image_url: string;
  showIcons?: boolean;
};

export type CardWidgetTheme = ClassicWidgetTheme & {};
